import styled from "styled-components";

import { stylesGlobalDefault } from "global/globalStyle";

export {
  Container,
  Content,
  LogoContainer,
  Title,
  Description,
  ErrorText,
  LanguageSelectorWrapper,
} from "pages/VerificationCode/styles";

export const MediaWrapper = styled.div`
  width: 100%;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const VideoPlayer = styled.video`
  width: 100%;
  max-height: 480px;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  background: #000;
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.2);
`;

export const MessageBox = styled.div`
  width: 100%;
  padding: 24px;
  border-radius: 12px;
  background-color: #f3f4f6;
  color: ${stylesGlobalDefault.blackMenu1};
  line-height: 1.6;
  text-align: center;
  box-shadow: inset 0 1px 4px rgba(15, 23, 42, 0.05);
`;

export const MessageWrapper = styled(MediaWrapper)`
  max-width: 520px;
  padding: 0 12px;
`;

export const LoadingMessage = styled.p`
  color: ${stylesGlobalDefault.gray};
  font-size: 16px;
  margin-top: 24px;
`;

export const MediaDescription = styled.p`
  color: ${stylesGlobalDefault.gray};
  font-size: 15px;
  line-height: 1.6;
  text-align: center;
`;

export const HearingMetadata = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin-top: 8px;
  color: ${stylesGlobalDefault.blackMenu1};
  font-size: 16px;
`;

export const HearingMetadataItem = styled.span`
  font-weight: 500;
`;

export const DownloadsSection = styled.div`
  width: 100%;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
`;

export const DownloadsTitle = styled.span`
  color: ${stylesGlobalDefault.gray};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

export const DownloadsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const DownloadsHelper = styled.span`
  color: ${stylesGlobalDefault.gray};
  font-size: 13px;
`;

export const MfaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 400px;
  gap: 16px;
`;

export const MfaDescription = styled.p`
  color: ${stylesGlobalDefault.gray};
  font-size: 16px;
  text-align: center;
  line-height: 1.5;
  margin-bottom: 8px;
`;

export const VerificationWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;

  > div {
    width: 100%;
  }

  .verification-container {
    width: 100%;
    margin-bottom: 8px;
    align-items: center;
    justify-content: center;
  }

  .verification-character {
    border-radius: 8px;
    font-size: 26px;
    text-align: center;
    align-items: center;
    border: 2px solid ${stylesGlobalDefault.inputsBorderFocusOff};
    transition: border 0.2s ease-in-out;
    color: ${stylesGlobalDefault.blackMenu1};
    margin: 0 3px;
  }

  .verification-character--inactive {
    border: 2px solid ${stylesGlobalDefault.inputsBorderFocusOff};
    background-color: white;
  }

  .verification-character--selected {
    border: 2px solid ${stylesGlobalDefault.blue};
    box-shadow: 0 0 5px rgba(29, 155, 240, 0.3);
  }

  .verification-character--filled {
    border: 2px solid ${stylesGlobalDefault.blue};
  }
`;

export const MfaButton = styled.button`
  background-color: ${stylesGlobalDefault.blue};
  color: ${stylesGlobalDefault.white};
  border: none;
  padding: 12px 36px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  max-width: 280px;

  &:hover {
    background-color: ${stylesGlobalDefault.blueDark};
    transform: translateY(-2px);
  }

  &:disabled {
    background-color: ${stylesGlobalDefault.inactivedButton};
    cursor: not-allowed;
    transform: none;
  }

  &:active {
    transform: translateY(0);
  }
`;

export const ResendCodeButton = styled.button`
  background: none;
  border: none;
  color: ${stylesGlobalDefault.blue};
  font-size: 14px;
  cursor: pointer;
  padding: 8px 16px;
  transition: opacity 0.2s ease;

  &:hover {
    text-decoration: underline;
  }

  &:disabled {
    color: ${stylesGlobalDefault.gray};
    cursor: not-allowed;
    text-decoration: none;
  }
`;

export const MfaErrorText = styled.p`
  color: ${stylesGlobalDefault.inputsBorderFocusError};
  font-size: 14px;
  text-align: center;
`;
